/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DataPlaneHarnessRouteImport } from './routes/data-plane-harness'
import { Route as DesignRouteImport } from './routes/design'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TerminalRouteImport } from './routes/terminal'
import { Route as AppsIndexRouteImport } from './routes/apps/index'
import { Route as AppsAppIdRouteImport } from './routes/apps.$appId'
import { Route as BoxIndexRouteImport } from './routes/box/index'
import { Route as BoxMessageIdRouteImport } from './routes/box.$messageId'
import { Route as AppsAppIdCodeRouteImport } from './routes/apps.$appId.code'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataPlaneHarnessRoute = DataPlaneHarnessRouteImport.update({
  id: '/data-plane-harness',
  path: '/data-plane-harness',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TerminalRoute = TerminalRouteImport.update({
  id: '/terminal',
  path: '/terminal',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIndexRoute = AppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAppIdRoute = AppsAppIdRouteImport.update({
  id: '/apps/$appId',
  path: '/apps/$appId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoxIndexRoute = BoxIndexRouteImport.update({
  id: '/box/',
  path: '/box/',
  getParentRoute: () => rootRouteImport,
} as any)
const BoxMessageIdRoute = BoxMessageIdRouteImport.update({
  id: '/box/$messageId',
  path: '/box/$messageId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAppIdCodeRoute = AppsAppIdCodeRouteImport.update({
  id: '/code',
  path: '/code',
  getParentRoute: () => AppsAppIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/data-plane-harness': typeof DataPlaneHarnessRoute
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/terminal': typeof TerminalRoute
  '/apps/$appId': typeof AppsAppIdRouteWithChildren
  '/box/$messageId': typeof BoxMessageIdRoute
  '/apps/': typeof AppsIndexRoute
  '/box/': typeof BoxIndexRoute
  '/apps/$appId/code': typeof AppsAppIdCodeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/data-plane-harness': typeof DataPlaneHarnessRoute
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/terminal': typeof TerminalRoute
  '/apps/$appId': typeof AppsAppIdRouteWithChildren
  '/box/$messageId': typeof BoxMessageIdRoute
  '/apps': typeof AppsIndexRoute
  '/box': typeof BoxIndexRoute
  '/apps/$appId/code': typeof AppsAppIdCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/data-plane-harness': typeof DataPlaneHarnessRoute
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/terminal': typeof TerminalRoute
  '/apps/$appId': typeof AppsAppIdRouteWithChildren
  '/box/$messageId': typeof BoxMessageIdRoute
  '/apps/': typeof AppsIndexRoute
  '/box/': typeof BoxIndexRoute
  '/apps/$appId/code': typeof AppsAppIdCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/data-plane-harness'
    | '/design'
    | '/login'
    | '/terminal'
    | '/apps/$appId'
    | '/box/$messageId'
    | '/apps/'
    | '/box/'
    | '/apps/$appId/code'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/data-plane-harness'
    | '/design'
    | '/login'
    | '/terminal'
    | '/apps/$appId'
    | '/box/$messageId'
    | '/apps'
    | '/box'
    | '/apps/$appId/code'
  id:
    | '__root__'
    | '/'
    | '/data-plane-harness'
    | '/design'
    | '/login'
    | '/terminal'
    | '/apps/$appId'
    | '/box/$messageId'
    | '/apps/'
    | '/box/'
    | '/apps/$appId/code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DataPlaneHarnessRoute: typeof DataPlaneHarnessRoute
  DesignRoute: typeof DesignRoute
  LoginRoute: typeof LoginRoute
  TerminalRoute: typeof TerminalRoute
  AppsAppIdRoute: typeof AppsAppIdRouteWithChildren
  BoxMessageIdRoute: typeof BoxMessageIdRoute
  AppsIndexRoute: typeof AppsIndexRoute
  BoxIndexRoute: typeof BoxIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-plane-harness': {
      id: '/data-plane-harness'
      path: '/data-plane-harness'
      fullPath: '/data-plane-harness'
      preLoaderRoute: typeof DataPlaneHarnessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terminal': {
      id: '/terminal'
      path: '/terminal'
      fullPath: '/terminal'
      preLoaderRoute: typeof TerminalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/': {
      id: '/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$appId': {
      id: '/apps/$appId'
      path: '/apps/$appId'
      fullPath: '/apps/$appId'
      preLoaderRoute: typeof AppsAppIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/box/': {
      id: '/box/'
      path: '/box'
      fullPath: '/box/'
      preLoaderRoute: typeof BoxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/box/$messageId': {
      id: '/box/$messageId'
      path: '/box/$messageId'
      fullPath: '/box/$messageId'
      preLoaderRoute: typeof BoxMessageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$appId/code': {
      id: '/apps/$appId/code'
      path: '/code'
      fullPath: '/apps/$appId/code'
      preLoaderRoute: typeof AppsAppIdCodeRouteImport
      parentRoute: typeof AppsAppIdRoute
    }
  }
}

interface AppsAppIdRouteChildren {
  AppsAppIdCodeRoute: typeof AppsAppIdCodeRoute
}

const AppsAppIdRouteChildren: AppsAppIdRouteChildren = {
  AppsAppIdCodeRoute: AppsAppIdCodeRoute,
}

const AppsAppIdRouteWithChildren = AppsAppIdRoute._addFileChildren(
  AppsAppIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DataPlaneHarnessRoute: DataPlaneHarnessRoute,
  DesignRoute: DesignRoute,
  LoginRoute: LoginRoute,
  TerminalRoute: TerminalRoute,
  AppsAppIdRoute: AppsAppIdRouteWithChildren,
  BoxMessageIdRoute: BoxMessageIdRoute,
  AppsIndexRoute: AppsIndexRoute,
  BoxIndexRoute: BoxIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
